'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('alignItems', 'align');


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/align-items.js
// module id = 647
// module chunks = 3